/*
 * Javascript for the home page
*/
(function($) {
	if($('body.countdown').length) {

		function makeTimer() {

					var endTime = new Date("30 August 2018 12:00:00 GMT+01:00");
					endTime = (Date.parse(endTime) / 1000);

					var now = new Date();
					now = (Date.parse(now) / 1000);

					var timeLeft = endTime - now;

					var days = Math.floor(timeLeft / 86400);
					var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
					var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
					var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

					if (hours < "10") { hours = "0" + hours; }
					if (minutes < "10") { minutes = "0" + minutes; }
					if (seconds < "10") { seconds = "0" + seconds; }

					$("#js-clock-hours").html(hours);
					$("#js-clock-minutes").html(minutes);
					$("#js-clock-seconds").html(seconds);

			}

			setInterval(function() { makeTimer(); }, 1000);
/*

		var deadline = '2018-08-30 12:00';

		function pad(num, size) {
			var s = "0" + num;
			return s.substr(s.length-size);
		}

		function getTimeRemaining(endtime) {
			var t = Date.parse(endtime) - Date.parse(new Date()),
				seconds = Math.floor((t / 1000) % 60),
				minutes = Math.floor((t / 1000 / 60) % 60),
				hours = Math.floor((t / (1000 * 60 * 60)) % 24),
				days = Math.floor(t / (1000 * 60 * 60 * 24));

			return {
				'total': t,
				'days': days,
				'hours': hours,
				'minutes': minutes,
				'seconds': seconds
			};
		}

		function clock(id, endtime) {
			var days = document.getElementById(id + '-days')
				hours = document.getElementById(id + '-hours'),
				minutes = document.getElementById(id + '-minutes'),
				seconds = document.getElementById(id + '-seconds');

			var timeinterval = setInterval(function() {
				var t = getTimeRemaining(endtime);

				if (t.total <= 0){
					clearInterval(timeinterval);
				} else {
					days.innerHTML = pad(t.days, 2);
					hours.innerHTML = pad(t.hours, 2);
					minutes.innerHTML = pad(t.minutes, 2);
					seconds.innerHTML = pad(t.seconds, 2);
				}
			}, 1000);
		}

		clock('js-clock', deadline);*/
	}
})(jQuery);
